function firstLetterToUpperCase(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export default { firstLetterToUpperCase };



// WEBPACK FOOTER //
// ./src/helpers/string.helper.js